import type { PhotoWriter as IPhotoWriter } from "../state/captureSession";
import { blobToImage, canvasToJpeg, imageToCanvas } from "../utils/canvas";

export class PhotoWriter implements IPhotoWriter {
  private quality: number;

  constructor(opts: { quality?: number } = {}) {
    this.quality = opts.quality ?? 0.85;
  }

  async write(image: Blob): Promise<Blob> {
    if (image.type === "image/jpeg") {
      return image;
    }
    const img = await blobToImage(image);
    const canvas = imageToCanvas(img);
    return canvasToJpeg(canvas, this.quality);
  }
}
